// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog__oiIP9"};